import LocationForm from './LocationForm';

export default LocationForm;
